module.exports = __webpack_public_path__ + "images/como-funciona.png";


//////////////////
// WEBPACK FOOTER
// ./images/como-funciona.png
// module id = 330
// module chunks = 1